import React, { FC } from "react";
import { DPPageWrapper } from "Components/DP";
import { Grid, Box, Typography, Link } from "@material-ui/core";
import useStyles from "Components/Pages/HelpAndDocs/styles";

const HelpAndDocs: FC = () => {
  const classes = useStyles();
  return (
    <DPPageWrapper title="Help & Docs">
      <Typography variant="h6">
        Thanks for using the new Partner Portal! Please send feedback about it
        to{" "}
        <Link href="mailto:feedback@dailypay.com">feedback@dailypay.com.</Link>
      </Typography>
      <Grid
        container
        item
        justify="space-between"
        className={classes.gridSection}
      >
        <Box className={classes.subSectionWrapper}>
          <Typography variant="h3">Contact Support</Typography>
          <span className={classes.containerGrid}>
            <Typography variant="body2" className={classes.term}>
              Email:
            </Typography>
            <Link
              href="mailto:partner.support@dailypay.com"
              className={classes.term}
            >
              partner.support@dailypay.com
            </Link>
          </span>
          <span className={classes.containerGrid}>
            <Typography variant="body2" className={classes.term}>
              Hours:
            </Typography>
            <Typography className={classes.detail}>
              Monday to Friday, 9 AM - 6 PM ET
            </Typography>
          </span>
        </Box>
        <Box className={classes.subSectionWrapper}>
          <Typography variant="h3">Resources</Typography>
          <Typography variant="body2">
            <Link
              href="https://partners.dailypay.com/hc/en-us"
              target="_blank"
              rel="noopener"
              className={classes.term}
            >
              Partner Help Center
            </Link>
          </Typography>
          <Typography variant="body2">
            <Link
              href="https://employee.dailypay.com/hc/en-us"
              className={classes.term}
              target="_blank"
              rel="noopener"
            >
              User Help Center
            </Link>
          </Typography>
          <Typography variant="body2">
            <Link
              href="https://business.dailypay.com/mediagallery/homepage"
              variant="body2"
              className={classes.term}
              target="_blank"
              rel="noopener"
            >
              Partner Resource Center
            </Link>
          </Typography>
        </Box>
      </Grid>
    </DPPageWrapper>
  );
};

export default HelpAndDocs;
